// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1RgUA","text":"SelectPayment_text__2tGYX","title":"SelectPayment_title__9M7ep","btn":"SelectPayment_btn__2rt2R"};